// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".placeholder[data-v-2fe01bf8]{color:#757575}", "",{"version":3,"sources":["webpack://./resources/assets/js/core/components/Forms/Title.vue"],"names":[],"mappings":"AAAA,8BAAA,aAAA","sourcesContent":[".placeholder{color:#757575}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
